let props = {
  headline: "Tragic collapse",
  standFirst:
    `<p>When Indonesia's Anak Krakatau volcano erupted on 22 December, 2018, the southwest part of the volcano collapsed into the ocean, causing a massive tsunami. Move the slider to compare satellite images taken in May 2018 and March 2019.</p>`,
  imageData: [
    {
      altText: "Aerial photograph of the Anak Krakatau volcano in Indonesia before the erruption.",
      caption: "Taken in May 2018.",
      srcURL: "img/volcano-slider-crop-before.jpg",
    },
    {
      altText: "Aerial photograph of the Anak Krakatau volcano in Indonesia after the erruption.",
      caption:
        "Taken in March 2019.",
      srcURL: "img/volcano-slider-crop-after.jpg",
    },
  ],
  ratio: 0.666666667,
  message: "Slide to reveal Anak Krakatau after the eruption:",
  credit: "Credit: Orbital Horizon/Copernicus Sentinel Data 2019/Gallo Images via Getty "
};

module.exports = props;
